import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {formatCurrencyFromCents} from '../../utils/format.util';

@Component({
  selector: 'bo-payout-request-kpi-card',
  templateUrl: './payout-request-kpi-card.component.html',
  styleUrls: ['./payout-request-kpi-card.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
})
export class PayoutRequestKpiCardComponent {
  @Input() title = '';
  @Input() value: number | null = null;
  @Input() subtitle = '';
  @Input() valueColor = '#FFFFFF';
  @Input() currency = 'EUR';
  @Input() locale = 'fr-FR';

  formatCurrencyFromCents = formatCurrencyFromCents;

  getFormattedValue(): string {
    return formatCurrencyFromCents(this.value);
  }
}

